/* eslint-disable  import/no-unused-modules */

import rootStoreInstance from "../../stores/rootStoreInstance";
import withProvider from "../../utilities/withProvider";
import HomeClaimModal from "./HomeClaimModal";

const ConnectedHomeClaimModal = withProvider(rootStoreInstance)(HomeClaimModal);

export { ConnectedHomeClaimModal as default, HomeClaimModal };
